export const LOGS_STATUS_ENUM = ["sent", "pending", "failed"] as const;
